import { SVGProps } from 'react';

const SvgSortDirection = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
        <path d="M9.6 11.4 7.2 9H9V3H7.2L9.6.6 12 3h-1.8v6H12M0 10.2V9h6v1.2M0 6.6V5.4h4.2v1.2M0 3V1.8h2.4V3H0Z" />
    </svg>
);
export default SvgSortDirection;
